import { render, staticRenderFns } from "./SettingsLandingPage.vue?vue&type=template&id=36a57989&scoped=true&"
import script from "./SettingsLandingPage.vue?vue&type=script&lang=js&"
export * from "./SettingsLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLandingPage.vue?vue&type=style&index=0&id=36a57989&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a57989",
  null
  
)

export default component.exports